import { render, staticRenderFns } from "./PromoItemsList.vue?vue&type=template&id=347b1fa1"
import script from "./PromoItemsList.vue?vue&type=script&lang=js"
export * from "./PromoItemsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports